import gql from 'graphql-tag';

const Query = {
  findPages: gql`
    query findPages($filters: CmsPageFilters, $pagination: PageInfoInput, $orderBy: CmsPageOrderByInput) {
      cmsPages(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
        nbHits
        hits {
          id
          slug
          type
          published
          publishAt
          name
          description
          color
          frontPage
          eventDate
          display_order
          covers(pagination: { offset: 0, limit: 1 }) {
            nbHits
            hits {
              id
              filename
              public_url
              mimetype
              createdAt
            }
          }
          createdAt
          updatedAt
          parent {
            id
            name
            type
            color
          }
          tags {
            id
            label
            slug
            color
            immutable
          }
        }
      }
    }
  `,
  findPage: gql`
    query findPage($id: Int!) {
      cmsPage(id: $id) {
        id
        slug
        type
        published
        publishAt
        name
        description
        color
        frontPage
        eventDate
        display_order
        content
        covers(pagination: { offset: 0, limit: 1 }) {
          nbHits
          hits {
            id
            filename
            public_url
            mimetype
            createdAt
          }
        }
        createdAt
        updatedAt
        parent {
          id
          name
          type
        }
        permission {
          id
          agentAccess
          staffAccess
          companies {
            nbHits
            hits {
              id
              code
              name
            }
          }
        }
      }
    }
  `,
  findPageSlug: gql`
    query findPageSlug($slug: String!) {
      cmsPageSlug(slug: $slug) {
        id
        slug
        type
        published
        publishAt
        name
        description
        color
        frontPage
        eventDate
        display_order
        content
        covers(pagination: { offset: 0, limit: 1 }) {
          nbHits
          hits {
            id
            filename
            public_url
            mimetype
            createdAt
          }
        }
        createdAt
        updatedAt
        parent {
          id
          name
          type
        }
        permission {
          id
          agentAccess
          staffAccess
          companies {
            nbHits
            hits {
              id
              code
              name
            }
          }
        }
        tags {
          id
          label
          slug
          color
          immutable
        }
      }
    }
  `,
  findPageWithChildrenAndParent: gql`
    query findPageWithChildrenAndParent(
      $id: Int!
      $filters: CmsPageFilters
      $pagination: PageInfoInput
      $orderBy: CmsPageOrderByInput
    ) {
      cmsPage(id: $id) {
        id
        type
        published
        publishAt
        name
        description
        color
        frontPage
        createdAt
        updatedAt
        color
        frontPage
        eventDate
        covers(pagination: { offset: 0, limit: 1 }) {
          nbHits
          hits {
            id
            filename
            public_url
            mimetype
            createdAt
          }
        }
        tags {
          id
          label
          slug
          color
          immutable
        }
        parent {
          id
          type
          published
          publishAt
          name
          description
          createdAt
          updatedAt
        }
        children(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
          nbHits
          hits {
            id
            type
            published
            publishAt
            name
            description
            color
            frontPage
            display_order
            content
            covers(pagination: { offset: 0, limit: 1 }) {
              nbHits
              hits {
                id
                filename
                public_url
                mimetype
                createdAt
              }
            }
            tags {
              id
              label
              slug
              color
              immutable
            }
            createdAt
            updatedAt
          }
        }
      }
    }
  `,
  findPageDetail: gql`
    query findPageDetail(
      $id: Int!
      $filters: CmsPageFilters
      $pagination: PageInfoInput
      $orderBy: CmsPageOrderByInput
    ) {
      cmsPage(id: $id) {
        id
        type
        published
        publishAt
        name
        description
        content
        color
        frontPage
        eventDate
        createdAt
        updatedAt
        covers {
          nbHits
          hits {
            id
            filename
            public_url
            mimetype
            createdAt
          }
        }
        documents(pagination: { offset: 0, limit: 20 }) {
          nbHits
          hits {
            id
            filename
            public_url
            mimetype
            createdAt
          }
        }
        tags {
          id
          label
          slug
          color
          immutable
        }
        parent {
          id
          type
          published
          publishAt
          name
          description
          createdAt
          updatedAt
          children(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
            nbHits
            hits {
              id
              type
              published
              publishAt
              name
              description
              covers(pagination: { offset: 0, limit: 1 }) {
                nbHits
                hits {
                  id
                  filename
                  public_url
                  mimetype
                  createdAt
                }
              }
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  `,
  findBreadcrumb: gql`
    query cmsBreadcrumb($pageId: Int!) {
      cmsBreadcrumb(pageId: $pageId) {
        nbHits
        hits {
          id
          name
          level
          createdAt
          updatedAt
        }
      }
    }
  `,
  getHubTreeStructure: gql`
    query getHubTreeStructure($pageId: Int!, $rootId: Int) {
      cmsTreeStructure(pageId: $pageId, rootId: $rootId) {
        nbHits
        hits {
          id
          parentId
          name
          type
          children_min_display_order
        }
      }
    }
  `,
  getAllTags: gql`
    query cmsTags {
      cmsTags {
        hits {
          id
          label
          slug
          color
          immutable
        }
        nbHits
      }
    }
  `,
  findTag: gql`
    query cmsTag($id: Int, $slug: StringFilter) {
      cmsTag(id: $id, slug: $slug) {
        id
        label
        slug
        color
        immutable
      }
    }
  `,
  getHubDeepChildren: gql`
    query getHubDeepChildren($rootId: Int!) {
      cmsDeepChildren(rootId: $rootId) {
        nbHits
        hits {
          id
          parentId
          name
          type
          description
          published
          publishAt
          content
          color
          frontPage
          eventDate
          createdAt
          updatedAt
          children_min_display_order
          covers(pagination: { offset: 0, limit: 1 }) {
            nbHits
            hits {
              id
              filename
              public_url
              mimetype
              createdAt
            }
          }
          documents(pagination: { offset: 0, limit: 20 }) {
            nbHits
            hits {
              id
              filename
              public_url
              mimetype
              createdAt
            }
          }
        }
      }
    }
  `,
};

const Mutation = {
  addPage: gql`
    mutation addCmsPage($params: CmsPageCreateUpdateInput!) {
      cmsPageCreate(params: $params) {
        id
        type
        published
        name
        description
      }
    }
  `,
  updatePage: gql`
    mutation updateCmsPage($id: Int!, $params: CmsPageCreateUpdateInput!) {
      cmsPageUpdate(id: $id, params: $params)
    }
  `,
  duplicatePage: gql`
    mutation cmsPageDuplication($originId: String!, $parentId: String!) {
      cmsPageDuplication(originId: $originId, parentId: $parentId)
    }
  `,
  updatePageCover: gql`
    mutation updateCmsPageCover($pageId: Int!, $files: [Upload!]!) {
      cmsPageCoverUpdate(pageId: $pageId, files: $files) {
        id
        filename
        type
        public_url
      }
    }
  `,
  deletePageCover: gql`
    mutation deleteCmsPageCover($pageId: Int!) {
      cmsPageCoverDelete(pageId: $pageId)
    }
  `,
  uploadDocuments: gql`
    mutation uploadDocuments($pageId: Int!, $files: [Upload!]!) {
      cmsPageUploadDocuments(pageId: $pageId, files: $files) {
        id
        filename
        type
        public_url
      }
    }
  `,
  deleteDocuments: gql`
    mutation deleteCmsPageDocument($pageId: Int!, $documentId: Int!) {
      cmsPageDocumentDelete(pageId: $pageId, documentId: $documentId)
    }
  `,
  uploadImages: gql`
    mutation uploadImages($pageId: Int!, $files: [Upload!]!) {
      cmsPageUploadImages(pageId: $pageId, files: $files) {
        id
        filename
        type
        public_url
      }
    }
  `,
  deletePage: gql`
    mutation cmsPagesDelete($pageId: Int!) {
      cmsPagesDelete(pageId: $pageId)
    }
  `,
  addPageTag: gql`
    mutation cmsPageAddTag($itemId: Int!, $tagId: Int!) {
      cmsPageAddTag(pageId: $itemId, tagId: $tagId)
    }
  `,
  removePageTag: gql`
    mutation cmsPageRemoveTag($itemId: Int!, $tagId: Int!) {
      cmsPageRemoveTag(pageId: $itemId, tagId: $tagId)
    }
  `,
  createTag: gql`
    mutation cmsCreateTag($label: String!, $color: String!) {
      cmsCreateTag(label: $label, color: $color) {
        id
        label
        color
      }
    }
  `,
  updateTag: gql`
    mutation cmsUpdateTag($id: Int!, $label: String!, $color: String!) {
      cmsUpdateTag(id: $id, label: $label, color: $color)
    }
  `,
};

export default {
  Query,
  Mutation,
};
